import { Dialog, DialogBody, DialogHeader } from "@material-tailwind/react";
import { FaArrowAltCircleRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { routerPaths } from "../../services/path";
import { Boat } from "../../models/boat/boat";
import { useSelectedBoatStore } from "../../store/boat/boatDetails";
type Props = {
  openDialog: boolean;
  handleOpen: () => void;
  boat: Boat;
};
function EditBoatModal(props: Props) {
  const navigate = useNavigate();
  const { setSelectedBoat } = useSelectedBoatStore();
  return (
    <Dialog
      placeholder={undefined}
      open={props.openDialog}
      handler={props.handleOpen}
      size="sm"
    >
      <div>
        <DialogHeader placeholder={undefined}>
          <h1 className="mx-auto">Edit Boat</h1>
        </DialogHeader>
        <DialogBody placeholder={undefined} className="text-black font-medium">
          <div
            onClick={() => {
              setSelectedBoat(props.boat);
              navigate(routerPaths.editPhotos);
            }}
            className="flex items-center justify-between p-4 bg-gray-200 rounded-md my-2"
          >
            <p>Photos</p>
            <FaArrowAltCircleRight />
          </div>
          <div
            className="flex items-center justify-between p-4 bg-gray-200 rounded-md my-2"
            onClick={() => {
              setSelectedBoat(props.boat);
              navigate(routerPaths.editPricing);
            }}
          >
            <p>pricing</p>
            <FaArrowAltCircleRight />
          </div>
        </DialogBody>
      </div>
    </Dialog>
  );
}

export default EditBoatModal;
